import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _throttle2 from "lodash/throttle";
/* eslint-env browser */
import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import classnames from 'classnames';
import { CardIcon } from '@latitude/card-icon';
import Section from '@latitude/section';
import Slider from '@latitude/slider';
import Slide from '@latitude/slide';
import { Text } from '@latitude/text';
import Image from '@latitude/image';
import { Heading4 } from '@latitude/heading';
import { Link } from '@latitude/link';
import SvgInline from '@latitude/svg-inline';
import BREAKPOINTS from '@latitude/core/data/json/breakpoints.json';
import { ALIGN, BUTTON_STYLE, COLOR, MARGIN } from '@latitude/core/utils/constants';
import './_features-and-benefits-slider.scss';
let FeaturesAndBenefitsSlider = /*#__PURE__*/function (_Component) {
  function FeaturesAndBenefitsSlider(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.componentDidMount = () => {
      const setSettings = () => {
        if (window.innerWidth < BREAKPOINTS.md) {
          _this.setState({
            settings: {
              className: 'center',
              centerMode: true,
              infinite: false,
              centerPadding: '20px'
            }
          });
        } else {
          _this.setState({
            settings: {
              infinite: false,
              centerMode: false,
              variableWidth: false,
              responsiveSettings: _this.props.responsiveSettings
            }
          });
        }
      };
      setSettings();
      // Throttle to 500ms to avoid "freezing" on window resize
      window.onresize = _throttle2(() => {
        setSettings();
      }, 500);
    };
    _this.componentWillUnmount = () => {
      window.onresize = null;
    };
    _this.getIcon = icon => {
      if (icon) {
        if (typeof icon === 'object') {
          return icon;
        }
        if (typeof icon === 'string') {
          return /*#__PURE__*/React.createElement(SvgInline, {
            className: "h-100 w-100",
            name: icon,
            strokeBlueBright: true
          });
        }
      }
      return undefined;
    };
    _this.state = {
      settings: {}
    };
    return _this;
  }
  _inheritsLoose(FeaturesAndBenefitsSlider, _Component);
  var _proto = FeaturesAndBenefitsSlider.prototype;
  _proto.render = function render() {
    const {
      heading,
      newBrand,
      subheading
    } = this.props;
    return /*#__PURE__*/React.createElement(Section, {
      id: this.props.id,
      className: `loan-used-for-categories ${this.props.className}`
    }, heading && newBrand ? /*#__PURE__*/React.createElement(Heading4, {
      align: ALIGN.CENTER,
      color: COLOR.BLACK,
      marginBottom: subheading ? MARGIN.M16 : MARGIN.M32
    }, ReactHtmlParser(heading)) : /*#__PURE__*/React.createElement("h2", {
      className: "loan-used-for-categories__title text-center",
      dangerouslySetInnerHTML: {
        __html: heading
      }
    }), subheading && /*#__PURE__*/React.createElement(Text, {
      align: ALIGN.CENTER
    }, subheading), /*#__PURE__*/React.createElement(Slider, Object.assign({}, this.state.settings, {
      className: "slider"
    }), this.props.data && this.props.data.map((category, i) => {
      return /*#__PURE__*/React.createElement(Slide, {
        key: i,
        className: classnames('slide', this.props.greyCards && 'bg-lightest')
      }, /*#__PURE__*/React.createElement(CardIcon, {
        newBrand: true,
        className: "h-100",
        thumbnail: Boolean(category.thumbnail),
        contained: Boolean(category.thumbnail),
        image: category.thumbnail ? /*#__PURE__*/React.createElement(Image, {
          rounded: true
          // eslint-disable-next-line import/no-dynamic-require
          ,

          src: require(`Images/${category.thumbnail}`),
          className: "mb-4"
        }) : this.getIcon(category.icon),
        title: category.title,
        titleClass: category.titleClass,
        cta: category.button ? /*#__PURE__*/React.createElement(Link, {
          href: category.button.link,
          button: BUTTON_STYLE.TERTIARY,
          trackId: category.title.toLowerCase().replace(/\s/g, "-"),
          trackEventData: {
            label: category.title,
            location: heading
          },
          trackProductId: category.trackProductId
        }, category.button.label) : null
      }, category.text && /*#__PURE__*/React.createElement("p", {
        className: classnames('m-0', !category.thumbnail && 'px-3')
        // eslint-disable-next-line react/no-danger
        ,

        dangerouslySetInnerHTML: {
          __html: category.text
        }
      }), category.jsx));
    })));
  };
  return FeaturesAndBenefitsSlider;
}(Component);
FeaturesAndBenefitsSlider.defaultProps = {
  id: 'needs',
  responsiveSettings: [{
    breakpoint: 10000,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1
    }
  }, {
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1
    }
  }, {
    breakpoint: 992,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 1
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1
    }
  }, {
    breakpoint: 450,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
};
export default FeaturesAndBenefitsSlider;